let lastTrackedPath = "";

function canUseBrowserApis() {
  return typeof window !== "undefined";
}

export function initAnalytics() {
  return canUseBrowserApis();
}

function pushDataLayerEvent(eventName, parameters = {}) {
  if (!eventName || !canUseBrowserApis()) {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...parameters,
  });

  return true;
}

export function trackPageView(path) {
  if (!path || !canUseBrowserApis()) {
    return;
  }

  if (lastTrackedPath === path) {
    return;
  }

  lastTrackedPath = path;

  const pageTitle = document.title;
  const pageLocation = `${window.location.origin}${path}`;

  pushDataLayerEvent("page_view", {
    page_path: path,
    page_title: pageTitle,
    page_location: pageLocation,
  });
}

export function trackConversionEvent(eventName, parameters = {}) {
  pushDataLayerEvent(eventName, {
    page_title: document.title,
    page_location: window.location.href,
    ...parameters,
  });
}

export function isAnalyticsEnabled() {
  return true;
}

export function resetAnalyticsTrackingState() {
  lastTrackedPath = "";
}
